var _circle, _circle2, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcOther = function SvgIcOther(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#FFDADA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.728,
    cy: 19.726,
    r: 16.9213,
    fill: "#FFEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4396 18.9473C14.663 18.9473 14.0361 19.5742 14.0361 20.3508C14.0361 21.1274 14.663 21.7543 15.4396 21.7543C16.2162 21.7543 16.8432 21.1274 16.8432 20.3508C16.8432 19.5742 16.2162 18.9473 15.4396 18.9473ZM23.8607 18.9473C23.0841 18.9473 22.4572 19.5742 22.4572 20.3508C22.4572 21.1274 23.0841 21.7543 23.8607 21.7543C24.6373 21.7543 25.2642 21.1274 25.2642 20.3508C25.2642 19.5742 24.6373 18.9473 23.8607 18.9473ZM19.6502 18.9473C18.8736 18.9473 18.2467 19.5742 18.2467 20.3508C18.2467 21.1274 18.8736 21.7543 19.6502 21.7543C20.4268 21.7543 21.0537 21.1274 21.0537 20.3508C21.0537 19.5742 20.4268 18.9473 19.6502 18.9473Z",
    fill: "#FF0303"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcOther, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-other.a216d9aa.svg";
export { ForwardRef as ReactComponent };